// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { ModifyStopOrder } from "../order-modify/ModifyStopOrder.js"
import { OrderTypeBase } from "./OrderTypeBase.js";
import { OrderType } from "../../../../Utils/Trading/OrderType.js"
import { DynProperty } from "../../../DynProperty.js"
import { OrderEditBaseUtils } from "../../../../Utils/Trading/OrderEditBaseUtils.js";
import { StopOrderEdit } from "../order-edit/StopOrderEdit.js";

export let StopOrderType = function ()
{
    OrderTypeBase.call(this, StopOrderEdit, ModifyStopOrder)

    this.stopPrice
}

StopOrderType.prototype = Object.create(OrderTypeBase.prototype)

// TODO. Remove.
StopOrderType.prototype.id = function ()
{
    return OrderType.Stop
}

StopOrderType.prototype.getOrderParameters = function ()
{
    let dpArray = OrderTypeBase.prototype.getOrderParameters.call(this)

    let dp = new DynProperty(OrderEditBaseUtils.STOP_PRICE_PARAM, this.stopPrice, DynProperty.DOUBLE)
    dpArray.push(dp)

    return dpArray
}
